import React from 'react';
import { createRoot } from 'react-dom/client';
// Tokens and the base layer must load before any component stylesheet, so
// component rules win at equal specificity.
import './styles/index.css';
import App from './App';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
